import { render, staticRenderFns } from "./skuCost.vue?vue&type=template&id=ff9c5f88&"
import script from "./skuCost.vue?vue&type=script&lang=js&"
export * from "./skuCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports